import React from 'react';
import { AlertCircle, TrendingDown } from 'lucide-react';
import { painPoints } from '../mockData';

const PainPoints = () => {
  return (
    <section className="py-20 bg-black text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-[#ED1C24]/10 via-black to-black"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#ED1C24]/20 rounded-full mb-6">
              <AlertCircle className="w-10 h-10 text-[#ED1C24]" />
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Dari pengalaman Arep & survei ke 1,000 trader,{' '}
              <span className="text-[#ED1C24]">ternyata banyak trader yang punya masalah yang sama</span>
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6">
            {painPoints.map((point, index) => (
              <div 
                key={index}
                className="bg-[#1a1a1a] border border-gray-800 rounded-2xl p-6 hover:border-[#ED1C24] transition-all hover:shadow-lg hover:shadow-[#ED1C24]/20"
              >
                <div className="flex items-start space-x-4">
                  <TrendingDown className="w-6 h-6 text-[#ED1C24] flex-shrink-0 mt-1" />
                  <p className="text-lg text-gray-300">{point}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <p className="text-2xl md:text-3xl font-bold text-white mb-8">
              Kalian mau gak, <span className="text-[#ED1C24]">Arep share cara biar bisa konsisten trading?</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;